import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { styled } from '@miro-site/ui-styled-engine';
import { Grid, GridItem, Box } from '@miro-site/ui-core';
import { useWindowScroll } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ImageGridItem = styled(GridItem, {
  width: '100%',
  height: '40vh',
  position: 'sticky',
  top: '56px',
  '@md': {
    top: '88px',
    height: 'calc(100vh - 72px)'
  },
  '@xxl': {
    top: '96px'
  }
});
var ContentGridItem = styled(GridItem, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'baseline',
  '&.scroll-item': {
    transition: 'opacity 0.3s ease',
    '&:not(.last-scroll-item)': {
      paddingBottom: '$400',
      marginBottom: '$400',
      borderBottom: '1px solid',
      borderBottomColor: '$blue-10'
    },
    '&.last-scroll-item': {
      marginBottom: '$600'
    },
    '&.active': {
      opacity: 1
    }
  },
  '@md': {
    flexDirection: 'column',
    justifyContent: 'center',
    height: 'calc(100vh - 91px)',
    alignItems: 'baseline',
    '&.scroll-item': {
      '&:not(.last-scroll-item)': {
        borderBottomWidth: '0'
      }
    }
  }
});

var SlidingContent = function SlidingContent(props) {
  var imageContainer = useRef(null);
  var mainContainer = useRef(null);

  var _useState = useState(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var previousScrollTop = 0;
  var currentActiveIndex = 0;
  var navbarHeight = 91;
  var imageContainerHeight = 0;

  var onWindowScroll = function onWindowScroll() {
    var currentScrollTop = window.scrollY;
    var isScrollingTop2Down = currentScrollTop > previousScrollTop;
    previousScrollTop = currentScrollTop;
    var elementBoundingBox = imageContainer.current.getBoundingClientRect();
    var mainContainerElement = mainContainer.current;
    var isMobileResolution = window.innerWidth <= 576;

    if (isMobileResolution && imageContainerHeight === 0) {
      imageContainerHeight = imageContainer.current.offsetHeight;
    }

    var nextElementIndex = isScrollingTop2Down ? currentActiveIndex + 1 : currentActiveIndex - 1;

    if (isScrollingTop2Down && nextElementIndex >= props.itemCount) {
      return;
    }

    if (!isScrollingTop2Down && nextElementIndex < 0) {
      return;
    }

    if (elementBoundingBox.top <= navbarHeight + 50 && elementBoundingBox.top > 0) {
      var _mainContainerElement;

      var nextElementBoundingBox = mainContainerElement === null || mainContainerElement === void 0 ? void 0 : (_mainContainerElement = mainContainerElement.querySelector('.scroll-item-' + nextElementIndex)) === null || _mainContainerElement === void 0 ? void 0 : _mainContainerElement.getBoundingClientRect();

      if (!nextElementBoundingBox) {
        return;
      }

      if (isMobileResolution) {
        //mobile resolution
        if (isScrollingTop2Down && nextElementBoundingBox.top <= imageContainerHeight + 100) {
          changeIndex(nextElementIndex);
        }

        if (!isScrollingTop2Down && nextElementBoundingBox.top >= imageContainerHeight + 100) {
          changeIndex(nextElementIndex);
        }

        return;
      } // desktop


      if (isScrollingTop2Down && nextElementBoundingBox.top < navbarHeight) {
        changeIndex(nextElementIndex);
      }

      if (!isScrollingTop2Down && nextElementBoundingBox.top > navbarHeight) {
        changeIndex(nextElementIndex);
      }
    }
  };

  var changeIndex = function changeIndex(newIndex) {
    if (newIndex !== currentActiveIndex) {
      setCurrentIndex(newIndex);
      currentActiveIndex = newIndex;
    }
  };

  useWindowScroll(onWindowScroll);
  var contentColumnProps = {
    start: {
      '@initial': 1
    },
    end: {
      '@initial': -1
    }
  };
  var imageColumnProps = {
    start: {
      '@initial': 1
    },
    end: {
      '@initial': -1
    }
  };

  if (props.contentColumnStartIndex && props.contentColumnStartIndex !== 1) {
    contentColumnProps.start['@md'] = props.contentColumnStartIndex;
  }

  if (props.contentColumnEndIndex && props.contentColumnEndIndex !== -1) {
    contentColumnProps.end['@md'] = props.contentColumnEndIndex;
  }

  if (props.imageColumnStartIndex && props.imageColumnStartIndex !== 1) {
    imageColumnProps.start['@md'] = props.imageColumnStartIndex;
  }

  if (props.imageColumnEndIndex && props.imageColumnEndIndex !== -1) {
    imageColumnProps.end['@md'] = props.imageColumnEndIndex;
  }

  return /*#__PURE__*/_jsx("div", {
    ref: mainContainer,
    children: /*#__PURE__*/_jsxs(Grid, {
      css: {
        gridRowGap: '0'
      },
      children: [_toConsumableArray(Array(props.itemCount)).map(function (_, index) {
        var _classNames;

        return /*#__PURE__*/_jsx(ContentGridItem, {
          columnStart: contentColumnProps.start,
          columnEnd: contentColumnProps.end,
          css: props.contentGridItemCss || {},
          asChild: true,
          children: /*#__PURE__*/_jsx("div", {
            className: classNames((_classNames = {
              'scroll-item': true,
              'last-scroll-item': index === props.itemCount - 1
            }, _defineProperty(_classNames, "scroll-item-".concat(index), true), _defineProperty(_classNames, "active", currentIndex === index), _classNames)),
            children: props === null || props === void 0 ? void 0 : props.slidingContentGenerator(index)
          })
        }, index);
      }), /*#__PURE__*/_jsx(ImageGridItem, {
        columnStart: imageColumnProps.start,
        columnEnd: imageColumnProps.end,
        rowStart: "1",
        asChild: true,
        css: props.imageGridItemCss || {},
        children: /*#__PURE__*/_jsx("div", {
          ref: imageContainer,
          children: /*#__PURE__*/_jsx(Box, {
            asChild: true,
            children: props === null || props === void 0 ? void 0 : props.slidingImageGenerator(currentIndex)
          })
        })
      })]
    })
  });
};

export default SlidingContent;